import seoTags from "@/apollo/queries/seoTags";
import folders from "@/apollo/queries/folder/folders";
import generations from "@/apollo/queries/generations";
import {mapGetters} from "vuex";
import seoTemplate from "@/apollo/queries/seoTemplate.gql";
import offerQuery from "@/apollo/queries/offer/offer";
import bankQuery from "@/apollo/queries/bank/bank";
import {renderSeoTemplate, seoTemplateName} from "~/utils/seoTemplate";

// SEO из шаблонов API (seoTemplate) — когда seoTag для страницы пустой (сейчас так для всего драйв-авто.рф)
async function seoFromTemplate({app, route, store}) {
    const client = app.apolloProvider.defaultClient
    const site_id = store.getters.site_id
    let templates = []
    try {
        const response = await client.query({query: seoTemplate, variables: {site_id}})
        templates = response.data?.seoTemplate || []
    } catch (e) {
        console.error('[seoTags] seoTemplate:', e.message)
        return null
    }

    const name = seoTemplateName(route)
    const isCatalog = name.startsWith('category')
    const template = templates.find(item => item.name === name && (!isCatalog || item.category === 'cars'))
    if (!template) return null

    const marks = store.getters['marks/marks/markFolderGeneration'] || []
    const mark = marks.find(item => item.slug === route.params.mark)
    const folder = mark?.folders?.find(item => item.slug === route.params.model)
    const generation = folder?.generations?.find(item => item.slug === route.params.car)

    let offer = null
    if (name === 'category-mark-folder-offer') {
        try {
            const response = await client.query({
                query: offerQuery,
                variables: {
                    site_id,
                    mark_slug: route.params.mark,
                    folder_slug: route.params.model,
                    external_id: Number(route.params.car),
                }
            })
            offer = response.data?.offer
        } catch (e) {
            console.error('[seoTags] offer:', e.message)
        }
        // Машины нет (продана / неверный id) — 404
        if (!offer) return null
    }

    let bank = null
    if (name === 'credit-bank') {
        try {
            const response = await client.query({query: bankQuery, variables: {site_id, slug: route.params.bank}})
            bank = response.data?.bank
        } catch (e) {
            console.error('[seoTags] bank:', e.message)
        }
    }

    return renderSeoTemplate(template, {
        catalogPath: route.params.category || 'cars',
        mark,
        folder,
        generation,
        offer,
        bank,
    })
}

export default {
    async asyncData({app, route, store, error}) {
        let client = app.apolloProvider.defaultClient

        let seo = null
        try {
            seo = await client.query({
                query: seoTags,
                variables: {site_id: store.getters.site_id, url: route.path === '/' ? '/home' : route.path}
            })
        } catch (e) {
            console.error('[seoTags] seoTag:', e.message)
        }
        let seoTag = seo?.data?.seoTag
        // seoTag пустой — берём SEO из шаблонов seoTemplate
        if (!seoTag || (!seoTag.title && !seoTag.page_title)) {
            const fromTemplate = await seoFromTemplate({app, route, store})
            if (fromTemplate) {
                seoTag = {
                    title: fromTemplate.title,
                    page_title: fromTemplate.page_title,
                    description: fromTemplate.description,
                    crumbs: fromTemplate.crumbs,
                }
            } else if (route.params.car && Number(route.params.car)) {
                return error({statusCode: 404, message: '404'})
            }
        }
        // console.log(store.getters['marks/marks/arrSet'])
        if(route.params.mark){

            let arrSet = store.getters['marks/marks/arrSet'];
            if(arrSet.includes(route.params.mark)){
                store.commit('folders/folders/SET_FOLDERS', null)
            }else{
                let currentMark = store.getters['marks/marks/markFolderGeneration'].find(item => item.slug === route.params.mark)
                let folders;
                if(currentMark.folders){
                    folders = [...currentMark.folders];
                    folders.sort((a, b) => parseFloat(b.offers_count) - parseFloat(a.offers_count))
                }
                store.commit('folders/folders/SET_FOLDERS', folders)
            }
        }
        if (route.params.model) {
            let currentMark = store.getters['marks/marks/markFolderGeneration'].find(item => item.slug === route.params.mark)
			let folders;
            let generations;
            let generationsSort;
			if(currentMark.folders){
			    folders = [...currentMark.folders];
			    folders.sort((a, b) => parseFloat(b.offers_count) - parseFloat(a.offers_count))
			}
            if(folders){
                generations = folders.find(item => item.slug === route.params.model)
            }
            if(generations){
                generationsSort = [...generations.generations];
                generationsSort = generationsSort.sort((a, b) => parseFloat(b.offers_count) - parseFloat(a.offers_count))
            }
            // let response = await client.query(
            //     {
            //         query: generations,
            //         variables: {
            //             site_id: store.getters.site_id,
            //             mark_slug: route.params.mark,
            //             folder_slug: route.params.model
            //         }
            //     })
            store.commit('generations/generations/SET_GENERATIONS', generationsSort)
        }
        return {
            description: seoTag?.description,
            pageTitle: seoTag?.page_title,
            title: seoTag?.title,
            crumbs: seoTag?.crumbs
        }
    },
    computed: {
        ...mapGetters({
            domain: 'domain',
            offer: 'catalog/catalog-cars/offer',
        }),
    },
    head() {
        let currentMeta = [
            {
                hid: 'desctiption',
                name: 'description',
                content: `${this.description}`
            },
            {
                hid: 'og:type',
                property: 'og:type',
                content: 'website',
            },
            {
                hid: 'og:url',
                property: 'og:url',
                content: this.domain + this.$route.path,
            },
            {
                hid: 'og:title',
                property: 'og:title',
                content: `${this.title}`
            },
            {
                hid: 'og:description',
                property: 'og:description',
                content: `${this.description}`
            },
            {
                rel: 'canonical',
                href: this.domain + this.$route.path
            }

        ]
        let canonicalDomain = this.domain + this.$route.path

        if (this.domain !== 'https://autodrive.spb.ru') {
            currentMeta.push({
                name: 'robots',
                content: 'noindex, nofollow'
            })
        }

        if (this.offer) {
            currentMeta.push({
                hid: 'og:image',
                property: 'og:image',
                content: this.offer.images[0].thumb
            })
        } else {
            currentMeta.push({
                hid: 'og:image',
                property: 'og:image',
                content: this.domain + '/preview.png'
            })
        }

        return {
            title: `${this.title}`,
            link: [
                {
                    rel: 'canonical',
                    href: this.domain + this.$route.path
                }
            ],
            meta: currentMeta
        }
    }
}